
import React, { useEffect, useState } from 'react';
import api from '../utils/api';
import resolveMediaUrl from '../utils/mediaUrl';

// section, category, title пропс-уудыг хүлээж авна
const ContentListBase = ({ section, category, title = 'Зарууд', themeMode }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedSection, setSelectedSection] = useState(section || '');
  const [selectedCategory, setSelectedCategory] = useState(category || '');
  const [categories, setCategories] = useState([]);

  // Төрөл/section-ууд
  const sectionOptions = [
    { value: '', label: 'Бүгд' },
    { value: 'info', label: 'Мэдээлэл' },
    { value: 'download', label: 'Татах' },
    { value: 'lesson', label: 'Хичээл' },
    { value: 'tech', label: 'Технологи' },
    { value: 'ad', label: 'Зар' },
  ];

  // Категори жагсаалтыг динамик олж авах (section солигдоход)
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await api.get('/content', { params: selectedSection ? { section: selectedSection } : {} });
        const cats = Array.from(new Set((res.data.items || []).map(i => i.category).filter(Boolean)));
        setCategories(cats);
      } catch {
        setCategories([]);
      }
    };
    fetchCategories();
  }, [selectedSection]);

  // Контентуудыг шүүх
  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const params = {};
        if (selectedSection) params.section = selectedSection;
        if (selectedCategory) params.category = selectedCategory;
        const response = await api.get('/content', { params });
        setItems(response.data.items || []);
      } catch (_error) {
        setItems([]);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [selectedSection, selectedCategory]);

  return (
    <div>
      <div style={{ display: 'flex', gap: 16, alignItems: 'center', marginBottom: 18 }}>
        <h2 style={{ margin: 0, fontWeight: 700, fontSize: 22 }}>{title}</h2>
        <select
          value={selectedSection}
          onChange={e => { setSelectedSection(e.target.value); setSelectedCategory(''); }}
          style={{ padding: '7px 14px', borderRadius: 8, border: '1px solid #ddd', fontSize: 16 }}
        >
          {sectionOptions.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
        </select>
        <select
          value={selectedCategory}
          onChange={e => setSelectedCategory(e.target.value)}
          style={{ padding: '7px 14px', borderRadius: 8, border: '1px solid #ddd', fontSize: 16 }}
        >
          <option value="">Бүх ангилал</option>
          {categories.map(cat => <option key={cat} value={cat}>{cat}</option>)}
        </select>
      </div>
      {loading ? (
        <div style={{ textAlign: 'center', margin: 40 }}>Уншиж байна...</div>
      ) : items.length === 0 ? (
        <div style={{ textAlign: 'center', margin: 40 }}>Одоогоор зар алга</div>
      ) : (
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: 28,
            margin: '0 auto',
            maxWidth: 1320,
            width: '100%'
          }}
        >
          {items.map((item) => (
            <div
              key={item._id}
              style={{
                background: '#fff',
                border: '1px solid #eee',
                borderRadius: 12,
                boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
                padding: 20,
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                minHeight: 340,
                transition: 'box-shadow 0.18s',
                maxWidth: 300,
                margin: '0 auto',
              }}
              onClick={() => window.location.href = `/content/${item._id}`}
            >
              {item.imageUrl && (
                <img
                  src={resolveMediaUrl(item.imageUrl)}
                  alt={item.title}
                  style={{ width: '100%', maxWidth: 210, maxHeight: 160, objectFit: 'cover', borderRadius: 10, marginBottom: 14 }}
                />
              )}
              <div style={{ fontWeight: 700, fontSize: 19, marginBottom: 10, textAlign: 'center', minHeight: 44 }}>{item.title}</div>
              {item.price && (
                <div style={{ color: '#2563eb', fontWeight: 600, marginBottom: 10, fontSize: 17 }}>{Number(item.price).toLocaleString()}₮</div>
              )}
              {item.description && (
                <div style={{ color: '#444', fontSize: 15, textAlign: 'center', marginBottom: 8, maxHeight: 44, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {item.description}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ContentListBase;
